import actions from 'src/modules/subscriptionTier/unarchive/subscriptionTierUnarchiveActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.UNARCHIVE_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.UNARCHIVE_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNARCHIVE_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNARCHIVE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.UNARCHIVE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNARCHIVE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
